export const MAIN_PAGE_ID = 'general-menu'
export const SERVICE_PAGE_ID = 'service-menu'
export const FOOTER_PAGE_ID = 'footer-menu'
